import { downloadFile, getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import { TYPES } from '../entities/internshipDocument'

export const getInternshipConvention = (internship, user) => {
  const parameters = { type: TYPES.CONVENTION, orderBy: 'updatedAt', orderDirection: 'desc' }

  return requestWithPromise(
    `/api/internships/${getIdOrNull(internship)}/documents${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  ).then(json => json?.data[0] ?? null)
}

const DEFAULT_PARAM_DOCUMENT = { id: -1, originalName: '' }
export const downloadInternshipDocument = (user, document = DEFAULT_PARAM_DOCUMENT) => {
  return downloadFile(`/internship/document/download/${getIdOrNull(document)}`, document.originalName, user)
}

export const deleteInternshipDocument = (user, document) => {
  return requestWithPromise(
    `/api/InternshipDocument/${getIdOrNull(document)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const updateInternshipDocument = (document, user) => {
  return requestWithPromise(
    `/api/InternshipDocument/${getIdOrNull(document)}`,
    HttpMethods.PATCH,
    { locked: true },
    user
  )
}

export const unlockInternshipDocument = (document, user) => {
  return requestWithPromise(
    `/internship/document/unlock/${getIdOrNull(document)}`,
    HttpMethods.PATCH,
    {},
    user
  )
}
